import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useCinemaDetection } from './useCinemaDetection';

import { themeVar, EAppTheme } from 'store/theme';

export const useTheme = () => {
  const router = useRouter();
  const isCinema = useCinemaDetection();

  useEffect(() => {
    if (isCinema) {
      const bodyEl = document.querySelector('body');

      if (ZnanieSDK) {
        queueMicrotask(() => ZnanieSDK.changeTheme(EAppTheme.DARK));
        themeVar({ ...themeVar(), name: EAppTheme.DARK });
        bodyEl?.classList.add('dark-bg');
      }

      return () => {
        ZnanieSDK.changeTheme(EAppTheme.LIGHT);
        themeVar({ ...themeVar(), name: EAppTheme.LIGHT });
        bodyEl?.classList.remove('dark-bg');
      };
    }
  }, [router]);
};
